import { LiteraturesComponent } from './literatures/literatures.component';
import { LiteraturesDetailComponent } from './literatures-detail/literatures-detail.component';

export const containers: any[] = [LiteraturesComponent, LiteraturesDetailComponent];

export * from './literatures/literatures.component';
export * from './literatures-detail/literatures-detail.component';
